export const VARIABLE_NAME = 'changeTargetingData';
